import { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { getScrollPosition } from "@/lib/scrollPositions";

/**
 * Scrolls window to top on navigation, unless the destination has a
 * saved scroll position (handled by per-page restoration hooks).
 */
export function ScrollToTop() {
  const { pathname, state } = useLocation();
  const navType = useNavigationType();

  // Disable the browser's automatic scroll restoration so we own it.
  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      const prev = window.history.scrollRestoration;
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = prev;
      };
    }
  }, []);

  useLayoutEffect(() => {
    if (navType === "POP") return;
    const isFresh = (state as any)?.fresh === true;
    // If the destination has a saved scroll position (and this isn't an
    // explicit fresh navigation), leave it to the page's own restore logic.
    if (!isFresh && getScrollPosition(pathname) != null) return;
    window.scrollTo(0, 0);
  }, [pathname, navType, state]);

  return null;
}

